module.exports = __webpack_public_path__ + "fonts/AkzidenzGroteskPro-Md.a900aa78.woff";